import request from '@/util/request'

/**
 * 添加二维码配置
 *
 * @param model
 * @returns {*}
 */
export function addQrCodeConfig(model) {
    return request({
        url: '/api-admin/qr_code_config',
        method: 'post',
        data: model
    })
}

export function editQrCodeConfig(model) {
    return request({
        url: '/api-admin/qr_code_config',
        method: 'put',
        data: model
    })
}

/**
 * 删除二维码
 *
 * @param params
 * @returns {*}
 */
export function delQrCodeConfigs(params) {
    return request({
        url: '/api-admin/qr_code_config',
        method: 'delete',
        data: params
    })
}

/**
 * 启用二维码配置
 *
 * @param params
 * @returns {*}
 */
export function enableQrCodeConfig(params) {
    return request({
        url: '/api-admin/qr_code_config/enable/' + params.code,
        method: 'put',
        query: {}
    })
}

/**
 * 禁用二维码配置
 *
 * @param params
 * @returns {*}
 */
export function disableQrCodeConfig(params) {
    return request({
        url: '/api-admin/qr_code_config/disable/' + params.code,
        method: 'put',
        query: {}
    })
}

